var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox",on:{"click":_vm.handleClick}},[_c('label',{class:{ checked: _vm.value },attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.value}}),_c('span')]),_c('span',{staticClass:"checkbox-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }